(function () {
  "use strict";
  var doc = document;
  var STATE = "data-xg-state";
  var timers = new Map();
  function reduced() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }
  function fadeMs() {
    var raw = getComputedStyle(doc.documentElement)
      .getPropertyValue("--xg-dur-micro").trim();
    var n = parseFloat(raw);
    if (!isFinite(n)) return 200;
    return raw.slice(-2) === "ms" ? n : n * 1000;
  }
  function messages(bar) {
    return bar.querySelectorAll("[data-xg-announce-msg]");
  }
  function currentIndex(list) {
    for (var i = 0; i < list.length; i += 1) {
      if (list[i].getAttribute(STATE) === "current") return i;
    }
    return 0;
  }
  function show(bar, next) {
    var list = messages(bar);
    if (list.length < 2) return;
    var from = currentIndex(list);
    if (from === next) return;
    for (var i = 0; i < list.length; i += 1) {
      if (i === next) list[i].setAttribute(STATE, "current");
      else if (i === from) list[i].setAttribute(STATE, "out");
      else list[i].removeAttribute(STATE);
    }
    var leaving = list[from];
    setTimeout(function () {
      if (leaving.getAttribute(STATE) === "out") leaving.removeAttribute(STATE);
    }, fadeMs() + 40);
  }
  function stop(bar) {
    var id = timers.get(bar);
    if (id) clearInterval(id);
    timers.delete(bar);
  }
  function start(bar) {
    stop(bar);
    if (bar.getAttribute("data-xg-announce-paused") !== null) return;
    var list = messages(bar);
    if (list.length < 2) return;
    var ms = parseInt(bar.getAttribute("data-xg-announce-interval"), 10);
    if (!isFinite(ms) || ms < 2000) ms = 5000;
    timers.set(
      bar,
      setInterval(function () {
        if (!doc.contains(bar)) {
          stop(bar);
          return;
        }
        if (doc.hidden) return;
        var items = messages(bar);
        show(bar, (currentIndex(items) + 1) % items.length);
      }, ms)
    );
  }
  function setPaused(bar, paused) {
    var button = bar.querySelector("[data-xg-announce-pause]");
    if (paused) bar.setAttribute("data-xg-announce-paused", "");
    else bar.removeAttribute("data-xg-announce-paused");
    if (button) {
      if (paused) button.setAttribute(STATE, "paused");
      else button.removeAttribute(STATE);
      button.setAttribute("aria-pressed", paused ? "true" : "false");
      var label = button.getAttribute(
        paused ? "data-xg-label-play" : "data-xg-label-pause"
      );
      if (label) button.setAttribute("aria-label", label);
    }
    if (paused) stop(bar);
    else start(bar);
  }
  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : doc;
    var bars = root.querySelectorAll("[data-xg-announce]");
    for (var i = 0; i < bars.length; i += 1) {
      var bar = bars[i];
      if (messages(bar).length < 2) continue;
      setPaused(bar, reduced());
    }
    timers.forEach(function (_id, el) {
      if (!doc.contains(el)) stop(el);
    });
  }
  doc.addEventListener("pointerover", function (event) {
    var bar = event.target.closest && event.target.closest("[data-xg-announce]");
    if (bar) stop(bar);
  });
  doc.addEventListener("pointerout", function (event) {
    var bar = event.target.closest && event.target.closest("[data-xg-announce]");
    if (bar) start(bar);
  });
  doc.addEventListener("focusin", function (event) {
    var bar = event.target.closest && event.target.closest("[data-xg-announce]");
    if (bar) stop(bar);
  });
  doc.addEventListener("focusout", function (event) {
    var bar = event.target.closest && event.target.closest("[data-xg-announce]");
    if (bar) start(bar);
  });
  doc.addEventListener("click", function (event) {
    var button =
      event.target.closest && event.target.closest("[data-xg-announce-pause]");
    if (!button) return;
    var bar = button.closest("[data-xg-announce]");
    if (!bar) return;
    setPaused(bar, bar.getAttribute("data-xg-announce-paused") === null);
  });
  doc.addEventListener("visibilitychange", function () {
    timers.forEach(function (_id, bar) {
      if (doc.hidden) stop(bar);
    });
    if (!doc.hidden) init(doc);
  });
  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", function () {
      init(doc);
    });
  } else {
    init(doc);
  }
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target || doc);
  });
  doc.addEventListener("shopify:section:unload", function () {
    init(doc);
  });
})();
